import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, addDoc, getDocs, query, orderBy, serverTimestamp, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function Events({ user }) {
  const [events, setEvents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({title:'',description:'',date:'',time:'',city:'',postcode:'',address:'',volunteers_needed:5,category:'community'});
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    const load = async () => {
      const snap = await getDoc(doc(db,'users',user.uid));
      if(snap.exists()) setProfile(snap.data());
      const q = query(collection(db,'events'),orderBy('created_at','desc'));
      const qs = await getDocs(q);
      setEvents(qs.docs.map(d=>({id:d.id,...d.data()})));
    };
    load();
  },[user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await addDoc(collection(db,'events'),{
      ...form, organizer_uid: user.uid,
      organizer_name: profile?.name||user.displayName,
      rsvp_list: [], volunteers_signed: 0,
      created_at: serverTimestamp(),
    });
    setShowForm(false);
    const q = query(collection(db,'events'),orderBy('created_at','desc'));
    const qs = await getDocs(q);
    setEvents(qs.docs.map(d=>({id:d.id,...d.data()})));
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'#F0FDF4'}}>
      <nav className="nav">
        <Link className="nav-brand" to="/"><div className="nav-logo">🏘</div><div className="nav-name">Community<span>Bridge</span></div></Link>
        <div className="nav-links">
          <Link to="/dashboard" className="nav-link">Home</Link>
          <Link to="/requests" className="nav-link">Requests</Link>
          <Link to="/events" className="nav-link active">Events</Link>
          <Link to="/volunteers" className="nav-link">Volunteers</Link>
        </div>
      </nav>
      <div className="page">
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'1.5rem',flexWrap:'wrap',gap:'1rem'}}>
          <div><h1 className="page-title">📅 Community Events</h1><p className="page-sub">Join or organize events in your neighborhood</p></div>
          <button className="btn btn-primary" onClick={()=>setShowForm(!showForm)}>+ Create Event</button>
        </div>

        {showForm && (
          <div className="card" style={{marginBottom:'1.5rem'}}>
            <h3 style={{fontSize:'18px',fontWeight:700,marginBottom:'1rem'}}>📅 New Event</h3>
            <form onSubmit={handleSubmit}>
              <div className="grid2">
                <div className="form-group"><label>Event Title</label><input value={form.title} onChange={e=>setForm({...form,title:e.target.value})} placeholder="Event name" required/></div>
                <div className="form-group">
                  <label>Category</label>
                  <select value={form.category} onChange={e=>setForm({...form,category:e.target.value})}>
                    <option value="community">🏘 Community</option>
                    <option value="cleanup">🧹 Cleanup</option>
                    <option value="fundraiser">💰 Fundraiser</option>
                    <option value="education">📚 Education</option>
                    <option value="health">🏥 Health</option>
                    <option value="social">🎉 Social</option>
                  </select>
                </div>
                <div className="form-group"><label>Date</label><input type="date" value={form.date} onChange={e=>setForm({...form,date:e.target.value})} required/></div>
                <div className="form-group"><label>Time</label><input type="time" value={form.time} onChange={e=>setForm({...form,time:e.target.value})}/></div>
                <div className="form-group"><label>City</label><input value={form.city} onChange={e=>setForm({...form,city:e.target.value})} placeholder="City"/></div>
                <div className="form-group"><label>Volunteers Needed</label><input type="number" value={form.volunteers_needed} onChange={e=>setForm({...form,volunteers_needed:Number(e.target.value)})} min={1}/></div>
              </div>
              <div className="form-group"><label>Full Address</label><input value={form.address} onChange={e=>setForm({...form,address:e.target.value})} placeholder="Street address or venue name"/></div>
              <div className="form-group"><label>Description</label><textarea rows={3} value={form.description} onChange={e=>setForm({...form,description:e.target.value})} placeholder="What is this event about?" required/></div>
              <div style={{display:'flex',gap:'8px'}}>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'Creating...':'Create Event'}</button>
                <button type="button" className="btn btn-gray" onClick={()=>setShowForm(false)}>Cancel</button>
              </div>
            </form>
          </div>
        )}

        <div className="grid2">
          {events.length===0 ? (
            <div className="card" style={{textAlign:'center',padding:'3rem',color:'#6B7280',gridColumn:'1/-1'}}>
              <div style={{fontSize:'48px',marginBottom:'12px'}}>📅</div>
              <p style={{fontWeight:600}}>No events yet. Create the first community event!</p>
            </div>
          ) : events.map(e=>(
            <div key={e.id} className="card">
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'8px'}}>
                <h3 style={{fontSize:'16px',fontWeight:700}}>{e.title}</h3>
                <span className="badge badge-blue">{e.category}</span>
              </div>
              <p style={{fontSize:'13px',color:'#4B5563',marginBottom:'10px',lineHeight:1.5}}>{e.description}</p>
              <div style={{fontSize:'12px',color:'#6B7280',display:'flex',flexDirection:'column',gap:'4px',marginBottom:'12px'}}>
                <span>📅 {e.date} {e.time && `at ${e.time}`}</span>
                <span>📍 {e.address}, {e.city}</span>
                <span>👥 {e.volunteers_signed||0}/{e.volunteers_needed} volunteers signed up</span>
                <span>👤 Organized by {e.organizer_name}</span>
              </div>
              <div style={{display:'flex',gap:'6px'}}>
                <button className="btn btn-primary" style={{flex:1,justifyContent:'center',fontSize:'13px'}}>✅ RSVP</button>
                <button className="btn btn-secondary" style={{flex:1,justifyContent:'center',fontSize:'13px'}}>🤝 Volunteer</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
